module.exports = __webpack_public_path__ + "img/default-avatar.6fb78cd6.png";